import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import Invitations from './pages/Invitations.jsx';
import Book from './pages/Book.jsx';
import About from './pages/About.jsx';
import NotFound from './pages/NotFound.jsx';
import Privacy from './pages/Privacy.jsx';
import Terms from './pages/Terms.jsx';
import Contact from './pages/Contact.jsx';
import Pricing from './pages/Pricing.jsx';
import WeddingInvitation from './pages/invitations/WeddingInvitation.jsx';
import ClassicElegance from './pages/wedding/templates/ClassicElegance.jsx';
import ModernRomance from './pages/wedding/templates/ModernRomance.jsx';
import RusticGarden from './pages/wedding/templates/RusticGarden.jsx';
import KidsPartyFun from './pages/birthday/templates/KidsPartyFun.jsx';
import ElegantMilestone from './pages/birthday/templates/ElegantMilestone.jsx';
import FiestaTheme from './pages/birthday/templates/FiestaTheme.jsx';
import AngelicWhite from './pages/christening/templates/AngelicWhite.jsx';
import BlessedJourney from './pages/christening/templates/BlessedJourney.jsx';
import ProfessionalBlue from './pages/corporate/templates/ProfessionalBlue.jsx';
import ExecutiveGold from './pages/corporate/templates/ExecutiveGold.jsx';
import SilverAnniversary from './pages/anniversary/templates/SilverAnniversary.jsx';
import GoldenYears from './pages/anniversary/templates/GoldenYears.jsx';
import CampingCelebration from './pages/invitations/designs/CampingCelebration.jsx';
import LeonCamping from './pages/invitations/designs/LeonCamping.jsx';
import './styles/App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ErrorBoundary>
        <Routes>
        {/* E-Invitation Display Routes (No Header/Footer) */}
        <Route path="/wedding/:designType/:coupleNames" element={<WeddingInvitation />} />
        <Route path="/wedding/templates/classic-elegance" element={<ClassicElegance />} />
        <Route path="/wedding/templates/classic-elegance/:coupleNames" element={<ClassicElegance />} />
        <Route path="/wedding/templates/modern-romance" element={<ModernRomance />} />
        <Route path="/wedding/templates/modern-romance/:coupleNames" element={<ModernRomance />} />
        <Route path="/wedding/templates/rustic-garden" element={<RusticGarden />} />
        <Route path="/wedding/templates/rustic-garden/:coupleNames" element={<RusticGarden />} />
        <Route path="/birthday/templates/kids-party-fun" element={<KidsPartyFun />} />
        <Route path="/birthday/templates/kids-party-fun/:celebrantName" element={<KidsPartyFun />} />
        <Route path="/birthday/templates/elegant-milestone" element={<ElegantMilestone />} />
        <Route path="/birthday/templates/elegant-milestone/:celebrantName" element={<ElegantMilestone />} />
        <Route path="/birthday/templates/fiesta-theme" element={<FiestaTheme />} />
        <Route path="/birthday/templates/fiesta-theme/:celebrantName" element={<FiestaTheme />} />
        <Route path="/christening/templates/angelic-white" element={<AngelicWhite />} />
        <Route path="/christening/templates/angelic-white/:childName" element={<AngelicWhite />} />
        <Route path="/christening/templates/blessed-journey" element={<BlessedJourney />} />
        <Route path="/christening/templates/blessed-journey/:childName" element={<BlessedJourney />} />
        <Route path="/corporate/templates/professional-blue" element={<ProfessionalBlue />} />
        <Route path="/corporate/templates/professional-blue/:eventName" element={<ProfessionalBlue />} />
        <Route path="/corporate/templates/executive-gold" element={<ExecutiveGold />} />
        <Route path="/corporate/templates/executive-gold/:eventName" element={<ExecutiveGold />} />
        <Route path="/anniversary/templates/silver-anniversary" element={<SilverAnniversary />} />
        <Route path="/anniversary/templates/silver-anniversary/:coupleNames" element={<SilverAnniversary />} />
        <Route path="/anniversary/templates/golden-years" element={<GoldenYears />} />
        <Route path="/anniversary/templates/golden-years/:coupleNames" element={<GoldenYears />} />
        
        {/* Custom Bespoke Invitations */}
        <Route path="/birthday-christening/camping" element={<CampingCelebration />} />
        <Route path="/birthday-christening/camping/n.a-leon-villamor-fortuna" element={<LeonCamping />} />
        <Route path="/birthday-christening/camping/:childName" element={<CampingCelebration />} />

        {/* Main Website Routes */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="invitations" element={<Invitations />} />
          <Route path="book" element={<Book />} />
          <Route path="about" element={<About />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="contact" element={<Contact />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        </Routes>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
